export const whiteTemplate = {
	primary: '#f3f3f6',
	secondary: '#fff',
	text: '#1f1f2d',
};
